import {
  Component,
  computed,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { UI_PIPES } from '@maximizer/core/shared/ui/pipes';
import { EntryStore } from '@maximizer/outlook/shared/data-access';
import {
  EntryType,
  OutlookAbEntryDetails,
} from '@maximizer/outlook/shared/domain';
import { TranslateVerticalPipe } from '@maximizer/outlook/shared/ui';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'maximizer-outlook-iq-boost-entry-context',
  imports: [TranslatePipe, UI_PIPES, TranslateVerticalPipe],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `<div class="flex flex-col gap-2">
    <p class="subtitle-2 text-neutral-90">
      {{
        'outlook.iqBoost.entryAsk'
          | translate
            : {
                type:
                  type() === EntryType.Individual
                    ? ('individual' | translateVertical)
                    : ('outlook.entries.' + type() | translate),
              }
      }}
    </p>
    <div
      class="p-2 flex items-center justify-between gap-1.5 border border-neutral-20 rounded-sm"
    >
      <span class="avatar avatar-xs">
        {{ name() | nameInitials }}
      </span>

      <div class="flex flex-col grow">
        <p class="text-body text-neutral-90 line-clamp-1">{{ name() }}</p>
        <p class="text-body text-neutral-70 line-clamp-1">
          {{ companyName() }}
        </p>
      </div>
    </div>
  </div>`,
})
export class OutlookIqBoostEntryContextComponent {
  readonly entryStore = inject(EntryStore);

  readonly EntryType = EntryType;

  entry = computed(() => this.entryStore.entry() as OutlookAbEntryDetails);

  type = computed(() => this.entry()?.type ?? '');
  name = computed(() => this.entry()?.name ?? '');
  companyName = computed(() => this.entry()?.companyName ?? '');
}
